import { GetDeletePhotoTrayPhotosOptions } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export const getDeletePhotoTrayPhotosTag = (options: GetDeletePhotoTrayPhotosOptions) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const deletePhotoTrayPhotosEvent = [
    {
      eventInfo: {
        eventName: 'delete photo',
        eventAction: options.photosDeleted.toString(), // Ensure the action is a string
      },
    },
  ];

  const { modal, user } = getModalTag(options.productType, 'Edit Mode', deletePhotoTrayPhotosEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
